import React from "react";

function RHelp() {
  return (
    <div style={{ padding: "20px" }}>
      <h1>MyAlfa RHelp</h1>
    </div>
  );
}

export default RHelp;
